import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import rankName from '../../utils/user/rankName';

/** Podium layout: 2nd (left), 1st (center), 3rd (right) */
const PODIUM_SLOTS = [
    {
        index: 1,
        pos: 2,
        podiumH: 'h-20',
        prize: '+600.000đ',
        img: '/img/ui/numberthree.png',
        avatarRing: 'ring-2 ring-line-strong',
        avatarSize: 'w-12 h-12',
        podiumColor: 'from-slate-400 to-slate-500',
    },
    {
        index: 0,
        pos: 1,
        podiumH: 'h-28',
        prize: '+1.000.000đ',
        img: '/img/ui/trophy2.png',
        avatarRing: 'ring-2 ring-amber-400',
        avatarSize: 'w-14 h-14',
        podiumColor: 'from-amber-400 to-yellow-500',
        crown: true,
    },
    {
        index: 2,
        pos: 3,
        podiumH: 'h-16',
        prize: '+400.000đ',
        img: '/img/ui/victory.png',
        avatarRing: 'ring-2 ring-orange-400',
        avatarSize: 'w-12 h-12',
        podiumColor: 'from-orange-400 to-orange-500',
    },
];

function PodiumAvatar({ userInfo, size, ring }) {
    return (
        <div className={`${size} ${ring} rounded-full bg-surface overflow-hidden flex items-center justify-center flex-shrink-0`}>
            {userInfo?.avatar ? (
                <img
                    className="w-full h-full object-cover"
                    src={`${process.env.REACT_APP_API_PUBLIC_URL}/img/users/${userInfo.avatar}`}
                    alt="avt"
                />
            ) : (
                <FontAwesomeIcon icon={faUser} className="text-content-3" />
            )}
        </div>
    );
}

function getUserName(user) {
    if (!user?.userInfo) return '---';
    return user.userInfo.name || `Người dùng ${user.userId}`;
}

function TopOrdersPodium({ users, onUserClick }) {
    return (
        <div className="flex items-end w-full pt-2">
            {PODIUM_SLOTS.map(({ index, pos, podiumH, prize, img, avatarRing, avatarSize, podiumColor, crown }) => {
                const user = users[index];
                const isFirst = pos === 1;

                return (
                    <div key={pos} className="flex-1 flex flex-col items-center">
                        {/* Crown / spacer */}
                        <div className="h-7 flex items-end justify-center">
                            {crown && <span className="text-2xl leading-none drop-shadow">👑</span>}
                        </div>

                        {/* Avatar */}
                        <PodiumAvatar userInfo={user?.userInfo} size={avatarSize} ring={avatarRing} />

                        {/* Name + rank */}
                        <div className="text-center px-1 mt-1 w-full">
                            <p className="text-xs font-bold line-clamp-1 text-white drop-shadow-sm">
                                {getUserName(user)}
                            </p>
                            <div className={`flex justify-center mt-0.5 ${isFirst ? '' : 'scale-90'}`}>
                                {user?.userInfo && rankName(user.userInfo.rank)}
                            </div>
                        </div>

                        {/* Orders count (clickable) */}
                        <button
                            className={`text-xs font-semibold mt-1 px-2 py-0.5 rounded-full transition-colors ${
                                user?.userId && user.userId !== '-'
                                    ? 'text-white hover:bg-surface/25 cursor-pointer'
                                    : 'text-white/40 cursor-default'
                            }`}
                            onClick={() => user?.userId && user.userId !== '-' && onUserClick?.(user)}
                        >
                            {user?.totalOrders || 0} đơn
                        </button>

                        {/* Podium block */}
                        <div className={`w-full ${podiumH} bg-gradient-to-b ${podiumColor} flex flex-col items-center justify-center rounded-t-xl shadow-inner mt-1.5`}>
                            <img src={img} alt={`top${pos}`} className="h-8 object-contain" />
                            <span className="text-white font-bold text-xs mt-1 drop-shadow">{prize}</span>
                        </div>
                    </div>
                );
            })}
        </div>
    );
}

export default TopOrdersPodium;
